<template>
  <div>
    <g-master name="skillgroup"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
              ref="master"
              @action="masterAction"
              :beforeSend="master.beforeSend"
              @params="paramsTable"
    >
      <template slot="customButton">
        <g-btn-excel :endpoint="`${master.endpoint}_/downloadExcel`" :params="paramsExcel" fileName="HABILIDADES Y CONOCIMIENTOS"/>
      </template>
      <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='INACTIVO' ? 'red' : (text === 'ACTIVO' ? 'blue' : 'red')">{{text}}</a-tag>
      </span>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Descripción')">
              <a-textarea autoSize
                          v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Tipo de presentación')"
                        :formItemConfig="fiOptions"
                        :decorator="['id_h_presentation_type', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                        :params="id_h_presentation_type">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Orden')">
              <a-input-number style="width: 100%"
                              v-decorator="['order', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Estado')" :has-feedback="false">
              <a-checkbox v-decorator="['status', {valuePropName: 'checked', initialValue: false}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Icono')">
              <a-input style="width: 100%"
                       v-decorator="['icon', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Peso (valor)')">
              <a-input-number style="width: 100%"
                              v-decorator="['value', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="SEGMENTO" key="1">
        <skill-subgroup v-if="idGroup" :id_group="idGroup" :id_evaluation="id_evaluation"></skill-subgroup>
        <span v-else>Seleccione un grupo para ver más.</span>
      </a-tab-pane>
    </a-tabs>

  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        id_h_presentation_type: {h_lookup_type: 'PRESENTACION_EVALUACION'},
        tipoObjetivo: {
          h_lookup_type: 'TIPO_OBJETIVO_EVALUACION_'
        },
        colOptions: {xs: 24, sm: 24},
        visible: false,
        nombre: '',
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            data.id_level = this.id_level
            return data
          },
          endpoint: 'skill_group',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Descripción', dataIndex: 'name', sorter: true},
              {title: 'Orden', dataIndex: 'order', sorter: true},
              {title: 'Tipo de presentación', dataIndex: 'tipo_presentacion', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Peso (valor)', dataIndex: 'value', sorter: true},
              {title: 'Icono', dataIndex: 'icon', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'order'},
            {name: 'status', type: 'boolean'},
            {name: 'id_h_presentation_type'},
            {name: 'icon'},
            {name: 'value'}
          ]
        },
        paramsT: {}
      }
    },
    props: ['id_evaluation'],
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      cancelImgRender () {
        this.imgRender = null
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (action.record.status === '1') {
              this.$refs.master.modal.form.setFieldsValue({
                status: true
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                status: false
              })
            }
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      parentData () {
        return {
          id_management_skill: this.id_evaluation
        }
      },
      idGroup () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.parentData}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/SkillsGroup.vue